import React from 'react';
import type { ButtonT } from '@mentimeter/ragnar-ui/button';
import { isAuthenticated, type ContentUserT } from '../../state/user';
import { HomeButton } from './HomeButton';
import { SignupButton } from './SignupButton';

interface HeaderButtonT extends ButtonT {
  user?: ContentUserT;
}

export const HeaderButton = (buttonProps: HeaderButtonT) => {
  const { user, ...props } = buttonProps;

  if (isAuthenticated(user)) {
    return <HomeButton {...props} />;
  }

  return <SignupButton {...props} />;
};
